module.exports = {
    path: '/',
    component: () => import('@dash/Dashboard'),
    children: [
        {
            path: '/',
            name: 'emptyPage',
            component: () => import('@dash/components/Layout/Construct/EmptyPage'),
            meta: { module: 'dash' }
        },
        {
            path: '/asset-life',
            component: () =>
                import('@dash/components/Layout/Construct/Leaderboard'),
            beforeEnter: (to, from, next) => {
                next('/asset-life');
            },
            meta: { module: 'dash' }
        },
        {
            path: '/notifications',
            component: () =>
                import('@dash/components/Layout/Construct/Notifications'),
            meta: { module: 'dash' }
        },
        {
            path: '/settings',
            component: () =>
                import('@dash/components/Layout/Construct/Settings'),
            meta: { module: 'dash' },
            children: [
                {
                    name: 'users',
                    path: 'users',
                    alias: '',
                    component: () =>
                        import(
                            '@dash/components/Layout/Construct/Settings/Users'
                        )
                },
                {
                    name: 'customers',
                    path: 'customers',
                    alias: '',
                    component: () =>
                        import(
                            '@dash/components/Layout/Construct/Settings/Customers'
                        )
                },
                {
                    name: 'sitegroups',
                    path: 'sitegroups',
                    alias: '',
                    component: () =>
                        import(
                            '@dash/components/Layout/Construct/Settings/SiteGroups'
                        )
                },
                {
                    name: 'uploads',
                    path: 'uploads',
                    component: () =>
                        import(
                            '@dash/components/Layout/Construct/Settings/Uploads'
                        )
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/router.js